import {Component, Input, OnInit} from '@angular/core';
import {Store} from "@ngrx/store";
import {AppState} from "../../store";
import {getFilterByKey} from "../../store/selectors/filter.selector";
import {setJobFilter} from "../../store/actions/filter.actions";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {combineLatest, take} from "rxjs";

@UntilDestroy()
@Component({
  selector: 'brt-distance-filter',
  templateUrl: './distance-filter.component.html',
  styleUrls: ['./distance-filter.component.scss']
})
export class DistanceFilterComponent implements OnInit {

  @Input('entity') set setEntity(val: "provider" | "job") {
    this.currentEntity = val;

    if(this.currentEntity === "provider") {
      this.settingsKey = "providersDistance";
      this.districtsFilterKey = "activeProviderDistrictIds";
      this.searchTermLocationKey = "searchTermProviderLocation";
      this.archiveFilterKey = "providersArchiveSortBy";
    } else if(this.currentEntity === "job") {
      this.settingsKey = "jobsDistance";
      this.districtsFilterKey = "activeJobDistrictIds";
      this.searchTermLocationKey = "searchTermJobLocation";
      this.archiveFilterKey = "jobsArchiveSortBy";
    }

    combineLatest({
      distanceValue: this.store.select(getFilterByKey(this.settingsKey)),
      activeDistrictIds: this.store.select(getFilterByKey(this.districtsFilterKey)),
      searchTermLocationsLocation: this.store.select(getFilterByKey(this.searchTermLocationKey))
    }).pipe(untilDestroyed(this)).subscribe(({distanceValue, activeDistrictIds, searchTermLocationsLocation}) => {

      if(activeDistrictIds.length === 0 && searchTermLocationsLocation.length === 0) {
        distanceValue = 0;
      }

      if(distanceValue === 0) {
        this.distanceValue = "";
      } else {
        this.distanceValue = distanceValue.toString();
      }




      if(this.oldDistanceValue !== distanceValue && distanceValue !== 0) {

        this.store.dispatch(setJobFilter({key: this.archiveFilterKey, value: "distance"}));
      }
      this.disabled = !activeDistrictIds.length && !searchTermLocationsLocation.length;

      if(this.disabled) {

        this.distanceValue = "";
        this.store.dispatch(setJobFilter({key: this.settingsKey, value: 0}));
      }

      this.oldDistanceValue = distanceValue;
    });


  }

  currentEntity: "provider" | "job" = "provider";
  districtsFilterKey = "";
  distanceValue: string = "";
  settingsKey = "";
  searchTermLocationKey = "";
  archiveFilterKey = "";
  oldDistanceValue = 0;

  disabled = true;

  constructor(private store: Store<AppState>) {
  }

  ngOnInit() {
  }


  valueChanged($event: any) {
    this.store.dispatch(setJobFilter({key: this.settingsKey, value: parseInt(this.distanceValue)}));
  }
}
